import { SubdivisionCreatableInterface } from '../interfaces/subdivision-creatable.interface';
import { SubdivisionDto } from './subdivision.dto';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';

export class SubdivisionCreateDto
  extends IntersectionType(
    PickType(SubdivisionDto, [
      'name',
      'address1',
      'city',
      'state',
      'zip',
      'builderId',
      'regionId',
      'active',
      'reqBumpoutTimesheet',
    ]),
    PartialType(
      PickType(SubdivisionDto, [
        'address2',
        'archived',
        'warrantyStatus',
        'overrideRegionCostPerBoard',
        'allowPayoutAmountEditing',
        'garageCostFixed',
        'specialJobsPercentage',
        'dwHangingCostPerBoard',
        'dwFinishingCostPerBoard',
        'dwSprayingCostPerBoard',
        'pieceworkPercentage',
        'highCeilingPerBoard',
        'screwInspectionPerBoard',
        'dwpHangingCostPerBoard',
        'dwpFinishCostPerBoard',
        'dwpPrimeCostPerSqft',
        'dwpBump1CostPerBoard',
        'dwpTrim1CostPerSqft',
        'dwpInteriorPaintCostPerSqft',
        'dwpBump2CostPerBoard',
        'dwpTrim2CostPerSqft',
        'dwpFinalPaintCostPerSqft',
        'dwpBump3CostPerBoard',
        'dwpCMBluetapeCostPerSqft',
        'dwpFinalBluetapeCostPerSqft',
        'phaseStructureType',
        'interiorOptionsPercentage',
        'exteriorOptionsPercentage',
        'trimOptionPercentage',
        'exteriorOnePercentage',
        'exteriorTwoPercentage',
        'overrideType',
        'geoDistanceTolerance',
      ]),
    ),
  )
  implements SubdivisionCreatableInterface {}
